"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamedSettingsContext = void 0;
const react_1 = require("react");
exports.NamedSettingsContext = react_1.createContext({
    getNamedSettings: () => Promise.resolve([]),
    saveNamedSettings: () => Promise.reject(),
    deleteNamedSettings: () => Promise.reject(),
    defaultTableNamedSettings: false,
});
//# sourceMappingURL=named-settings-context.js.map